import { createSlice } from "@reduxjs/toolkit"

const aiPlannerSlice = createSlice({
  name: "aiPlanner",
  initialState: {
    isGenerating: false,
    /** Persisted session: retains generated posts when navigating away until all posts are moved (scheduled or drafts) */
    persistedSession: null,
  },
  reducers: {
    startGeneration: (state) => {
      state.isGenerating = true
    },
    completeGeneration: (state) => {
      state.isGenerating = false
    },
    saveAIPlannerSession: (state, { payload }) => {
      state.persistedSession = payload
    },
    updateAIPlannerSessionIds: (state, { payload }) => {
      if (!state.persistedSession) return
      if (payload.scheduledGeneratedPostIds) {
        state.persistedSession.scheduledGeneratedPostIds = payload.scheduledGeneratedPostIds
      }
      if (payload.draftGeneratedPostIds) {
        state.persistedSession.draftGeneratedPostIds = payload.draftGeneratedPostIds
      }
    },
    clearAIPlannerSession: (state) => {
      state.persistedSession = null
    },
  },
})

export const {
  startGeneration,
  completeGeneration,
  saveAIPlannerSession,
  updateAIPlannerSessionIds,
  clearAIPlannerSession,
} = aiPlannerSlice.actions
export default aiPlannerSlice.reducer
